import { random } from 'lodash-es'
import { IPartsBasketVehicleInfo } from '../api/embedded/types/partsBasket-1.1'
import { SearchedPartTypes } from '../features/partsCatalog/Selections/interfaces'
import { ISelectedOption } from '../features/search/AllProductsSearch/LanguagesDropdown'
import { MultiPartInquiry } from '../features/search/AllProductsSearch/interfaces'
import { Vehicle } from '../store/models/Vehicles'
import { ISimpleVehicle } from 'src/api/cart/interfaces'
import { Translate2 } from 'common'

export const getRandomVehicleId = (): number => {
  // return Math.random().toString(36).slice(2)
  return random(10000000, 99999999)
}

export const getYMMENumberFromVehicle = (vehicle: Vehicle): string =>
  `${vehicle.year?.id},${vehicle.make?.id},${vehicle.model?.id},${vehicle.engine?.id}`

export const getLaborRateFromCurrencyString = (laborRate: string): string =>
  laborRate.replace('$', '')

export const hasVehicleInfoDetails = (
  vehicleInfo?: IPartsBasketVehicleInfo
): boolean => {
  if (!vehicleInfo) {
    return false
  }
  return Boolean(
    vehicleInfo.ymmeNo ||
      vehicleInfo.ymme ||
      vehicleInfo.vin ||
      vehicleInfo.licencePlate ||
      vehicleInfo.aaia ||
      vehicleInfo.aces
  )
}

export const getSRCForImage = (urlOrBase64: string): string => {
  const isBase64 = !urlOrBase64?.startsWith('http')
  const src = isBase64 ? `data:image/jpeg;base64,${urlOrBase64}` : urlOrBase64
  return src
}

export const getBlobUrlFromBase64 = (urlOrBase64: string): string => {
  const base64ImageData = getSRCForImage(urlOrBase64)
  const contentType = 'image/jpeg'
  const byteCharacters = atob(
    base64ImageData.substr(`data:${contentType};base64,`.length)
  )
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: contentType })
  const blobUrl = URL.createObjectURL(blob)
  return blobUrl
}

export const capitaliseOption = (option: ISelectedOption): string => {
  return option.label.charAt(0).toUpperCase() + option.label.slice(1)
}

export const download = (
  data: string,
  filename: string,
  type: string
): void => {
  const file = new Blob([data], { type })
  // @ts-expect-error Code copied from aes To maintain compatibility.
  if (window.navigator.msSaveOrOpenBlob)
    // @ts-expect-error Code copied from aes To maintain compatibility.
    window.navigator.msSaveOrOpenBlob(file, filename)
  else {
    const a = document.createElement('a')
    const url = URL.createObjectURL(file)

    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export const createMultiPartInquiryBreadcrumb = (
  partsToSearch: MultiPartInquiry[]
): string => {
  const breadCrumbParts: string[] = []
  partsToSearch.forEach((part) => {
    breadCrumbParts.push(part.partNumber)
  })

  if (breadCrumbParts.length < 3) {
    return breadCrumbParts.join(' | ')
  } else {
    return `${breadCrumbParts.slice(0, 2).join(' | ')} +${
      breadCrumbParts.length - 2
    } more`
  }
}

export const createBreadcrumbs = (
  partsToSearch: SearchedPartTypes[]
): string => {
  const breadCrumbParts: string[] = []
  partsToSearch.forEach((part) => {
    breadCrumbParts.push(part.value)
  })

  if (breadCrumbParts.length < 3) {
    return breadCrumbParts.join(' | ')
  } else {
    return `${breadCrumbParts.slice(0, 2).join(' | ')} +${
      breadCrumbParts.length - 2
    } more`
  }
}

export const isJSON = (obj: string): boolean => {
  try {
    JSON.parse(obj)
  } catch (_e) {
    return false
  }
  return true
}

const EULA_BASE_URL = 'https://myplace-eula-dxp-dr.s3.amazonaws.com/qa-eula'

export const getEulaUrl = (language: string): string => {
  const langForUrl = language === 'French' ? `${language}CA` : language
  return `${EULA_BASE_URL}/MyPlace+EULA+2025_${langForUrl}.html`
}

export const translateApiScheduleText = (text: string | undefined): string => {
  if (!text) return ''
  return text.replace(/Deliver by/gi, Translate2('deliverBy'))
}

export const formatVehicleDisplay = (
  vehicle: Vehicle,
  includeMake = true,
  includeEngine = true
): string => {
  const parts = [
    vehicle?.year?.value,
    includeMake ? vehicle?.make?.value : null,
    vehicle?.model?.value,
    vehicle?.subModel?.value ?? '',
    includeEngine ? vehicle?.engine?.value : null,
  ]
    .filter(Boolean)
    .join(' ')

  return parts.replace('MISCELLANEOUS', Translate2('miscellaneousText'))
}
/**
 * @deprecated Update the formatVehicleDisplay to handle this using a param.
 * @param vehicle
 * @returns
 */
export const formatVehicleDisplayWithOutEngine = (
  vehicle: Vehicle,
  includeMake = true
): string => {
  const parts = [
    vehicle?.year?.value,
    includeMake ? vehicle?.make?.value : null,
    vehicle?.model?.value,
    vehicle?.subModel?.value ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  // Handle MISCELLANEOUS translation directly in the utility
  return parts.replace('MISCELLANEOUS', Translate2('miscellaneousText'))
}

export const formatVehicleShortDisplayWithOutEngine = (
  vehicle: ISimpleVehicle
): string => {
  const parts = [
    vehicle?.year,
    vehicle?.make,
    vehicle?.model,
    vehicle?.subModel ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  // Handle MISCELLANEOUS translation directly in the utility
  return parts.replace('MISCELLANEOUS', Translate2('miscellaneousText'))
}
